import { render, staticRenderFns } from "./PdvDashboardView.vue?vue&type=template&id=007bd46c"
import script from "./PdvDashboardView.vue?vue&type=script&lang=ts"
export * from "./PdvDashboardView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports